import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiHome, FiTool, FiStar } = FiIcons;

const MissionSnapshot = () => {
  const pillars = [
    {
      icon: FiHeart,
      title: 'Rescue',
      description: 'Identifying and reaching out to those in need with compassion and care.'
    },
    {
      icon: FiHome,
      title: 'Shelter',
      description: 'Providing safe, secure homes where dignity and hope are restored.'
    },
    {
      icon: FiTool,
      title: 'Skill Training',
      description: 'Empowering individuals with practical skills for sustainable livelihoods.'
    },
    {
      icon: FiStar,
      title: 'Dignity',
      description: 'Restoring self-respect and confidence for a life of independence.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Mission</h2>
          <p className="text-xl text-orange-600 font-medium italic">
            "Not charity, but dignity."
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, index) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={pillar.icon} className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{pillar.title}</h3>
              <p className="text-gray-600">{pillar.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSnapshot;